import Clipboard from '@react-native-clipboard/clipboard';
import React, {useEffect, useState} from 'react';
import {Share, Platform} from 'react-native';
import {useTheme} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import analytics from '@react-native-firebase/analytics';

import {Header as HeaderButton} from '../../components/Interface/Headers/Header';
import {Button} from '../../components/Interface/Forms/Buttons/Button';
import {Toast} from '../../components/Interface/Toast';

import {StepList} from '../../components/Interface/List/StepList';

import {useAuth} from '../../context/auth';
import thumbVideoIndGanhe from '../../assets/images/banners/thumb-indique.webp';

import {
  Container,
  Content,
  IconContainer,
  Icon,
  Title,
  InfoText,
  LinkTitle,
  CodeArea,
  Code,
  CopyCodeButton,
  CopyCodeIcon,
  SectionTitle,
  ContentHeader,
  Section,
  SectionHeader,
  List,
  Footer,
  ContentHeaderIcon,
  HelpVideoContainer,
  HelpVideoThumb,
} from './styles';

import {addInAppTrigger} from '../../lib/pushMessaging';
import {HelpVideo} from '../../components/shared/HelpVideo';

import {useHelpers} from '../../context/helpers';
import {useGlobal} from '../../context/global';
import {Step} from '../../components/Interface/Step';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useBaratinhas } from '../../hooks/useBaratinhas';
import {Maintenance} from '../../components/Interface/Maintenance';


export function ReferAndWin() {
  const theme = useTheme();

  const {user, isLogged, openSign} = useAuth();
  const {handleConfiguraBaratinhas, configuracaoBaratinhas} = useBaratinhas();
  const {formatNumberToLocaleAmount} = useHelpers();
  const [loadingBaratinhas, setLoadingBaratinhas] = useState(true);

  const {configIndiqueGanhe, disabledFeatures} = useGlobal();
  const isDisabled = (key: string) => disabledFeatures.includes(key);

  const message = `Lembrei de você!\n\nConheça o MELHOR aplicativo de descontos em combustíveis do Brasil:\nBARATÃO COMBUSTÍVEIS\n\nAbasteça pagando menos! Já somos mais de 3 milhões de usuários economizando todos os dias.\n\n🚨 Atenção: no cadastro, insira o meu código:\n👉 *${user.codCompartilhar}*\n(Com ele você tem mais descontos!)\n\n📲 Baixe agora e comece a economizar:\nGoogle Play: https://play.google.com/store/apps/details?id=com.barataoapp&referrer=${user.codCompartilhar}\nApple Store: https://apps.apple.com/app/id1613535824?at=${user.codCompartilhar}\n\n🎥 Ficou com dúvida?\nAssista a este vídeo rápido:\nhttps://youtube.com/shorts/YvoeFT5oTAM?si=Vx6qMnu9Gci5gXaJ`;

  useEffect(() => {
    if (Platform.OS !== 'web') {
      addInAppTrigger('screen', 'refer_and_win');
    }
  }, []);

  const [showToast, setShowToast] = useState(false);

  async function onShare() {
    analytics().logEvent('clica_compartilhar_indique_e_ganhe');
    try {
      await Share.share({
        message,
      });
    } catch (error) {
      console.log(error);
    }
  }

  const copyToClipboard = () => {
    analytics().logEvent('clica_copiar_codigo_indique_ganhe');
    Clipboard.setString(user.codCompartilhar);
    setShowToast(true);
  };

  useEffect(() => {
    analytics().logEvent('tela_indique_e_ganhe');
    async function fetchaBaratinhasConfig() {
      try {
        await handleConfiguraBaratinhas();
        setLoadingBaratinhas(false);
      } catch (error) {
        console.log(error);
      }
    }

    fetchaBaratinhasConfig();
  }, []);

  const [showVideo, setShowVideo] = useState(false);

  const baratinhasValueResgateMinimo =
    (configuracaoBaratinhas.limiteResgate *
      configuracaoBaratinhas.cotacaoCents) /
    100;

  if (isDisabled('indique')) {
    return <Maintenance />;
  }

  return (
    <SafeAreaView style={{flex: 1}} edges={['bottom']}>
    <Container>
      {showToast && (
        <Toast
          type="info"
          text="Código copiado"
          timeout={2000}
          onEnd={() => setShowToast(false)}
        />
      )}
      <HelpVideoContainer onPress={() => setShowVideo(true)} activeOpacity={1}>
        <HelpVideoThumb source={thumbVideoIndGanhe}>
          <HeaderButton
            icon="chevron-left"
            statusBarLight
            color={theme.colors.shape}
          />
        </HelpVideoThumb>
      </HelpVideoContainer>

      <Content>
        <ContentHeader>
          <ContentHeaderIcon>
            <IconContainer
              style={{
                shadowColor: theme.colors.text_dark,
                shadowOffset: {width: 0, height: 7},
                shadowOpacity: 0.2,
                shadowRadius: 6,
                elevation: 8,
              }}>
              <Icon name="gift" />
            </IconContainer>
          </ContentHeaderIcon>

          <Title>Indique e ganhe</Title>
          <InfoText>
            A cada pessoa indicada que abastecer com o Baratão, você ganha! Tem gente ganhando mais de R$1.300/mês. Só indicando. E você?
          </InfoText>

          {isLogged && (
            <Step
              order={2}
              contextName="indique2"
              text="Esse é o seu código exclusivo! Compartilhe com seus amigos e, sempre que eles abastecerem, você ganha BaratinhaZ direto no seu saldo.">
              <LinkTitle>Seu código de indicação</LinkTitle>
              <CodeArea>
                <Code>{user.codCompartilhar}</Code>
                <CopyCodeButton onPress={copyToClipboard} activeOpacity={1}>
                  <CopyCodeIcon name="copy" />
                </CopyCodeButton>
              </CodeArea>
            </Step>
          )}
        </ContentHeader>
        <Section
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{paddingBottom: RFValue(20)}}>
          <SectionHeader>
            <SectionTitle>Como funciona:</SectionTitle>
          </SectionHeader>

          <List>
            <StepList number={1} text="Copie o código de indicação." />
            <StepList number={2} text="Envie-o para todos os seus amigos!" />
            <StepList
              number={3}
              text="A cada litro comprado por cada amigo indicado, você ganha baratinhaZ!"
            />
            <StepList
              number={4}
              text={`Você pode usar suas baratinhaZ como desconto no checkout. É necessário acumular o valor mínimo de ${
                loadingBaratinhas
                  ? '••••'
                  : formatNumberToLocaleAmount(baratinhasValueResgateMinimo)
              } em baratinhaZ para usá-las como desconto na compra.`}
            />
            <StepList
              number={5}
              text="Alguns cupons promocionais não são válidos para compras com baratinhaZ."
            />
            <StepList
              number={6}
              text={`Você pode indicar até ${
                (configIndiqueGanhe &&
                  configIndiqueGanhe[configIndiqueGanhe.length - 1]
                    ?.limite_indicados) ??
                '••••'
              } pessoas. Este limite pode variar de acordo com seu uso do Baratão.`}
            />
          </List>
        </Section>
      </Content>

      <Footer>

          {isLogged ? (
            <Step
              order={3}
              contextName="indique2"
              text="Clique em compartilhar, mande seu código para os amigos e veja seu saldo crescer toda vez que eles abastecerem.">
              <Button title="Compartilhar" onPress={onShare} variant="outline" enabled />
            </Step>
          ) : (
            <Button
              title="Entre para indicar agora"
              onPress={() => openSign()}
              variant="outline"
              enabled
            />
          )}

      </Footer>

      {showVideo && (
        <HelpVideo
          onVideoEnd={() => setShowVideo(false)}
          videoURI={
            'https://d3ag5cip9ldvh3.cloudfront.net/INDIQUEGANHE.MP4'
          }
        />
      )}
    </Container>
    </SafeAreaView>
  );
}
